import { Table } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';
import usePagination from 'hooks/usePagination';
import { updateFilterResults } from 'redux/reducer/manageArtworkSlice';

import ActivityLogBody from '../../TableArtistPanel/Common/ActivityLogBody';
import ActivityLogHead from '../../TableArtistPanel/Common/ActivityLogHead';
import TableWrapper from '../../TableWrapper';

const TableActivityLogs = () => {
  const [sortDirection, setSortDirection] = useState('desc');

  const user = useSelector((state) => state.auth.account.user);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const pageSize = 10;
  const currentPage = Number(searchParams.get('page')) || 1;

  const params = useMemo(() => {
    const searchValue = (searchParams.get('search') || '').toString().trim();
    const p = {
      user_uuid: user?.uuid,
      page: currentPage,
      page_size: pageSize,
      ordering: sortDirection === 'desc' ? '-created_at' : 'created_at',
    };
    if (searchValue) {
      p.search = searchValue;
    }
    return p;
  }, [user?.uuid, currentPage, pageSize, sortDirection, searchParams]);

  const { data, isPending, isFetching } = useQuery({
    queryKey: [API.ACTIVITY_LOG.ARTWORK_LOGS, params],
    gcTime: 0,
    enabled: !!user?.uuid,
    placeholderData: (prev) => prev,
  });

  const count = data?.count ?? data?.results?.length ?? 0;

  const { page, totalPage, onPageChange } = usePagination(count, pageSize);

  const handleSortChange = (newSortDirection) => {
    setSortDirection(newSortDirection);
  };

  useEffect(() => {
    dispatch(updateFilterResults(count));
  }, [count, dispatch]);

  return (
    <TableWrapper
      page={page}
      totalPage={totalPage}
      onPageChange={onPageChange}
    >
      <Table>
        <ActivityLogHead
          sortDirection={sortDirection}
          onSortChange={handleSortChange}
        />
        <ActivityLogBody
          activityLogs={data?.results}
          loading={isPending || isFetching}
          page={page}
          pageSize={pageSize}
        />
      </Table>
    </TableWrapper>
  );
};

export default TableActivityLogs;
